export const GENERAL_INTEREST_ID = '__PATIENT_DATABASE_GENERAL_INTEREST__';
export const GENERAL_INTEREST_NAME = 'General Interest';
export const EMPTY_VALUE_ID = '__PATIENT_DATABASE_EMPTY_VALUE__';
export const EMPTY_VALUE_NAME = 'Empty';

export const PARENT_ROW = 'parent';
export const CHILD_ROW = 'child';

export const PATIENT_DATABASE_TABLE_NAME = 'PATIENT_DATABASE';
export const PATIENT_DATABASE_TABLE_VERSION = '1.00';

export const OPT_IN = 'Opt-In';
export const OPT_OUT = 'Opt-Out';
export const ADDITIONAL_COMMUNICATION_OPTIONS = [OPT_IN, OPT_OUT];

export const WEBFORM_SOURCE_NAME = 'Webform';

export const PATIENT_LEAD_STATUS_PENDING_REVIEW = 'Pending Review';
export const PATIENT_LEAD_STATUS_REVIEWED = 'Reviewed';
export const PATIENT_LEAD_STATUS_FAILED_REVIEW = 'Failed Review';
export const PATIENT_LEAD_STATUS_PUSHED_TO_PRE_SCREENING = 'Pushed to Pre-Screening';

export const PATIENT_LEAD_STATUS_OPTIONS = [
  PATIENT_LEAD_STATUS_PENDING_REVIEW,
  PATIENT_LEAD_STATUS_REVIEWED,
  PATIENT_LEAD_STATUS_FAILED_REVIEW,
  PATIENT_LEAD_STATUS_PUSHED_TO_PRE_SCREENING
];

export const INITIAL_FILTERS_STATE = {
  ssu: {
    studySites: [],
    studies: [],
    sites: [],
    selectedStudyMap: {},
    selectedSiteMap: {},
    selectedStudies: [],
    selectedSites: []
  },
  therapeuticArea: {
    source: [],
    value: []
  },
  indication: {
    source: [],
    value: []
  }
};

export const COLUMNS_HIDDEN_BY_DEFAULT = {
  patientId: false,
  email: false,
  phoneNumber: false,
  source: false,
  communicationOption: false,
  smsOptIn: false,
  createdAt: false,
  updatedAt: false
};
